import { useCallback, useEffect, useImperativeHandle, useState } from "react";
function useActionBar(params) {
  const { actions, onChanged, buttonRef, onClick } = params;
  const [open, setOpen] = useState(false);
  const onOpen = useCallback(
    (e) => {
      e.stopPropagation();
      setOpen(buttonRef?.current !== null);
    },
    [buttonRef]
  );
  const openApi = useCallback(() => {
    setOpen(buttonRef?.current !== null);
  }, [buttonRef]);
  const onClose = useCallback(() => {
    setOpen(false);
  }, []);
  const toggleApi = useCallback(() => {
    setOpen((prevOpenState) => buttonRef.current !== null ? !prevOpenState : false);
  }, [buttonRef]);
  useEffect(() => onChanged?.(open), [open, onChanged]);
  useImperativeHandle(
    actions,
    () => ({
      close: onClose,
      open: openApi,
      toggle: toggleApi
    }),
    [onClose, openApi, toggleApi]
  );
  const menuOpen = buttonRef.current !== null && open;
  const parentOnClick = (item) => {
    onClick?.(item);
    onClose();
  };
  return {
    menuOpen,
    onClose,
    onOpen,
    parentOnClick
  };
}
export {
  useActionBar
};
//# sourceMappingURL=useActionBar.js.map
